module.exports = __webpack_public_path__ + "static/media/economy.60a2a3d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/economy/economy.svg
// module id = 63
// module chunks = 0